<svi-navbar></svi-navbar>
<svi-page-title>{{ (footerLinks | async)?.title }}</svi-page-title>
<svi-page-content>
  <div class="cms" [innerHTML]="(doc | async)?.html"></div>
</svi-page-content>
